import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import '../styles/MyProjects.css';

import { getDataFromFirestore, deleteProjectByInternalId } from '../firebaseService';
import Loader from './Loader.js';
function MyProjects({ user, setUser }) {
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);
const [projects, setProjects] = useState([]);

const printPDF = () => {
  const element = document.querySelector(".canvas-grid");

  if (!element) {
    alert("Блок для печати не найден!");
    return;
  }
  html2canvas(element, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape", "mm", "a4");
  
    // Отримаємо розміри сторінки та формуємо PDF
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const ratio = Math.min(pdfWidth / canvasWidth, pdfHeight / canvasHeight);
  
    const imgWidth = canvasWidth * ratio;
    const imgHeight = canvasHeight * ratio;
  
    // Центруємо картинку на сторінці
    const xOffset = (pdfWidth - imgWidth) / 2;
    const yOffset = (pdfHeight - imgHeight) / 2;
  
    pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
    pdf.save("document.pdf");
  });

}

const deleteProj =  async (id)=> {
setLoading(true);
const updatedProjects = projects.filter(project => project.id !== id);
    setProjects(updatedProjects);
   await deleteProjectByInternalId(id)
setLoading(false);
}

const editProj = (id)=> {
  navigate(`/edit/${id}`);
}

useEffect(() => {
  setLoading(true);
  // const storedProjects = localStorage.getItem('projects');
  const getProjects = async () => {
  await getDataFromFirestore().then((data) => {
      if(data)   setProjects(data); 
    
    })
  }
  getProjects();
setLoading(false);
 
}, [navigate]);

 useEffect(() => {
    // Redirect to "/" after logout
   if(!user) navigate('/');
  }, [navigate,user]);


const userProjects = projects.filter(item => user === item.user);

  return (
    <div>
          <Header user = {user} setUser = {setUser} />
                          <h2>Мої соціальні проєкти</h2>
                <div className="canvas-container">
                {loading ? <Loader/> :  userProjects.length > 0 ? (

userProjects.map((project, index) => (
<div key={index}>
<div  className="canvas-grid">
    <div className="grid-item name">  Назва соціального проєкту: {project.data.name}</div>
   <div className="grid-item problem"> <span>Проблема користувачів, яку вирішуємо: </span> {project.data.problem}</div>
  <div className="grid-item customer_segments"><span>Сегменти користувачів:</span> {project.data.customer_segments}</div>
  <div className="grid-item unique_value"><span>Унікальна цінність:</span>  {project.data.unique_value_proposition}</div>
  <div className="grid-item solution"><span>Вирішення проблеми:</span> {project.data.solution}</div>
  <div className="grid-item channels"><span>Канали:</span> {project.data.channels}</div>
  <div className="grid-item cost_structure"><span>Структура витрат:</span> {project.data.cost_structure}</div>
  <div className="grid-item revenue_streams"><span>Прибуток:</span> {project.data.revenue_streams}</div>
  <div className="grid-item key_metric"><span>Ключові метрики:</span> {project.data.key_metrics}</div>
  <div className="grid-item unfair_advan"><span>Неринкова перевага:</span> {project.data.unfair_advantage}</div>
       </div>
       <div className='buttons'>
<button onClick={printPDF} className="print-button" >Зберігти у файл</button>
<button onClick={()=>editProj(project.id)} className="edit-button" >Редагувати</button>
<button onClick={()=>deleteProj(project.id)} className="delete-button" >Видалити</button>
</div>
</div>
))
): (
<p className="no-projects-message">У вас немає проєктів. Створіть новий, щоб почати.</p>
)
}
 
    </div>
    </div>
  )
}

export default MyProjects
